import { useMutation } from '@tanstack/react-query';
import { login, type LoginRequest } from '@/api/auth';

export function useLoginMutation() {
  return useMutation({
    mutationFn: (payload: LoginRequest) => login(payload),
  });
}
